<template>

  <section class="why section">

      <div class="container">
          <div class="row">
        <div class="heading col-12">
            <h3>You + us = <strong class="color-2">win win</strong></h3>
            <h4 class="legend">We search the best ways to create software - by combining industry-leading technologies and choosing the correct agile methodology. </h4>
        </div>

          </div>
      </div>



      <div class="container">
          <div class="row">

        <div class="ill-technology">
          <ul class="ill-technology-list">
            <li class="ill-technology-item pos1">Domain knowledge</li>
            <li class="ill-technology-item pos2">Business</li>
            <li class="ill-technology-item pos3">Services</li>
            <li class="ill-technology-item pos4">Our Expertise</li>
          </ul>
          <div class="ill-technology-cirlce">
            <div class="ill-technology-cirlce_main"></div>
            <div class="ill-technology-cirlce_small pos1"></div>
            <div class="ill-technology-cirlce_small pos2"></div>
            <div class="ill-technology-cirlce_large pos1"></div>
            <div class="ill-technology-cirlce_large pos2"></div>
            <div class="ill-technology-cirlce_large pos3"></div>
            <div class="ill-technology-cirlce_large pos4"></div>
          </div>
        </div>


          </div>
      </div>

  </section>

</template>

<script>
export default {
  name: 'Why',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


section.why {
  background-color: #171820;
  overflow: hidden;
}

.ill-technology {
    position: relative;
    height: 370px;
    margin: 30px auto 0
}
.ill-technology-list {
    margin: 0;
    list-style: none
}
.ill-technology-item {
    position: absolute;
    left: 50%;
    -moz-transform: translate(-50%, 0);
    -webkit-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    font-size: 13px;
    color: white;
    text-transform: uppercase;
}
.ill-technology-item.pos1 {
    top: -30px
}
.ill-technology-item.pos2 {
    top: 140px;
    -moz-transform: translate(-185px, 0);
    -webkit-transform: translate(-185px, 0);
    -o-transform: translate(-185px, 0);
    -ms-transform: translate(-185px, 0);
    transform: translate(-185px, 0)
}
.ill-technology-item.pos3 {
    top: 140px;
    -moz-transform: translate(115px, 0);
    -webkit-transform: translate(115px, 0);
    -o-transform: translate(115px, 0);
    -ms-transform: translate(115px, 0);
    transform: translate(115px, 0)
}
.ill-technology-item.pos4 {
    bottom: 35px
}

.ill-technology-item.pos1,
.ill-technology-item.pos4 {
  width: 200px;
  text-align: center;
}

.ill-technology-cirlce {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0
}
.ill-technology-cirlce_main {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 50%;
    width: 300px;
    height: 305px;
    background: url("/static/img/layout/circle1.svg") 50% 0 no-repeat;
    -moz-transform: translate(-50%, 0);
    -webkit-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0)
}
.ill-technology-cirlce_main:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 100px;
    background: url("/static/img/layout/circle4.svg") 0 0 no-repeat, url("/static/img/layout/circle4.svg") 100% 0 no-repeat;
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}
.ill-technology-cirlce_main:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url("/static/img/layout/circle5.svg") 50% 50% no-repeat
}
.ill-technology-cirlce_small {
    position: absolute;
    top: 100px;
    left: 50%;
    width: 100px;
    height: 100px;
    -moz-transform: translate(-50%, 0);
    -webkit-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    background: url("/static/img/layout/circle2.svg") 0 0 no-repeat
}
.ill-technology-cirlce_small.pos1 {
    margin: 0 0 0 -150px
}
.ill-technology-cirlce_small.pos2 {
    margin: 0 0 0 150px
}
.ill-technology-cirlce_large {
    position: absolute;
    top: 0;
    left: 50%;
    width: 302px;
    height: 305px;
    -moz-transform: translate(-50%, 0);
    -webkit-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    background: url("/static/img/layout/circle3.svg") 0 0 no-repeat
}
.ill-technology-cirlce_large.pos1 {
    margin: 0 0 0 150px
}
.ill-technology-cirlce_large.pos2 {
    margin: 0 0 0 250px
}
.ill-technology-cirlce_large.pos3 {
    margin: 0 0 0 -150px
}
.ill-technology-cirlce_large.pos4 {
    margin: 0 0 0 -250px
}
@media only screen and (max-width: 767px) {
    .section-technology-intro {
        line-height: 1.5;
        margin-bottom: 50px
    }
    .section-technology-intro .section-title {
        padding: 0
    }
    .section-technology-intro hr {
        max-width: 100px;
        height: 2px;
        margin: 25px auto 30px
    }
    .section-technology-intro .section-intro-text {
        max-width: none
    }
    .ill-technology {
        height: 300px;
        margin-top: 0;
        -webkit-transform: scale(0.8);
        -moz-transform: scale(0.8);
        -ms-transform: scale(0.8);
        -o-transform: scale(0.8);
        transform: scale(0.8)
    }
    .ill-technology-item.pos4 {
        bottom: -35px
    }
}




</style>



// WEBPACK FOOTER //
// src/components/Why.vue